module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    attrs: {
      "id": "toc",
      "title": "Contents"
    }
  }, [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "firstverse"
  }, [_c('b', [_c('a', {
    attrs: {
      "href": "#/Text/Introduction"
    }
  }, [_vm._v("AN INTRODUCTION: Short Flights and Quick Returns")])])]), _vm._v(" "), _c('p', {
    staticClass: "firstverse"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/OWPACSLewis"
    }
  }, [_c('span', {
    staticClass: "indent"
  }, [_vm._v("One Who Paid Attention:")]), _vm._v(" "), _c('i', [_vm._v("C. S. Lewis Looking Along a Beam")])])]), _vm._v(" "), _c('p', {
    staticClass: "firstverse"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/chap1"
    }
  }, [_c('b', [_vm._v("1: PAYING ATTENTION: The Hours of Our Lives")])])]), _vm._v(" "), _c('p', {
    staticClass: "firstverse"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/OWPAWeil",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "indent"
  }, [_vm._v("One Who Paid Attention:")]), _vm._v(" "), _c('i', [_vm._v("Simone Weil on a Postage Stamp")])])]), _vm._v(" "), _c('p', {
    staticClass: "firstverse"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap2",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("2: THE BIRTHING HOUR: Time Before Time")])])]), _vm._v(" "), _c('p', {
    staticClass: "firstverse"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/OWPADonovan",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "indent"
  }, [_vm._v("One Who Paid Attention:")]), _vm._v(" "), _c('i', [_vm._v("Vincent Donovan—the Masai Chief, the Missionary and the Lion God")])])]), _vm._v(" "), _c('p', {
    staticClass: "firstverse"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap3",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("3: DAYBREAK: The Hour of Beginnings")])])]), _vm._v(" "), _c('p', {
    staticClass: "firstverse"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/OWPATeacher",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "indent"
  }, [_vm._v("One Who Paid Attention:")]), _vm._v(" "), _c('i', [_vm._v("The Teacher Who Took Off His Hat")])])]), _vm._v(" "), _c('p', {
    staticClass: "firstverse"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap4",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("4: PRIME TIME: Our Root System")])])]), _vm._v(" "), _c('p', {
    staticClass: "firstverse"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/OWPADog",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "indent"
  }, [_vm._v("One Who Paid Attention:")]), _vm._v(" "), _c('i', [_vm._v("My Spiritual Director Dog")])])]), _vm._v(" "), _c('p', {
    staticClass: "firstverse"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap5",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("5: ACTIVE LIFE: A Slower Pace in a Faster World")])])]), _vm._v(" "), _c('p', {
    staticClass: "firstverse"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/OWPAKierkegaard",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "indent"
  }, [_vm._v("One Who Paid Attention:")]), _vm._v(" "), _c('i', [_vm._v("Kierkegaard’s Lanterns, Fireworks and Stars")])])]), _vm._v(" "), _c('p', {
    staticClass: "firstverse"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap6",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("6: THE NOONDAY DEMON: Our Distractible Selves")])])]), _vm._v(" "), _c('p', {
    staticClass: "firstverse"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/OWPAMTeresa",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "indent"
  }, [_vm._v("One Who Paid Attention:")]), _vm._v(" "), _c('i', [_vm._v("How Mother Teresa Kept Going")])])]), _vm._v(" "), _c('p', {
    staticClass: "firstverse"
  }, [_c('b', [_c('span', {
    attrs: {
      "href": "#/Text/HolyStillness",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("HOLY STILLNESS: An Interlude")])])]), _vm._v(" "), _c('p', {
    staticClass: "firstverse"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap7",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("7: WHEN SHADOWS COME: Darkness Comes Early")])])]), _vm._v(" "), _c('p', {
    staticClass: "firstverse"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/OWPASittser",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "indent"
  }, [_vm._v("One Who Paid Attention:")]), _vm._v(" "), _c('i', [_vm._v("Jerry Sittser Trying to Catch the Sun")])])]), _vm._v(" "), _c('p', {
    staticClass: "firstverse"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap8",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("8: LIGHTING THE LAMPS: The House with Golden Windows")])])]), _vm._v(" "), _c('p', {
    staticClass: "firstverse"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/OWPANouwen",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "indent"
  }, [_vm._v("One Who Paid Attention:")]), _vm._v(" "), _c('i', [_vm._v("Henri Nouwen, a Restless Prophet")])])]), _vm._v(" "), _c('p', {
    staticClass: "firstverse"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap9",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("9: GRANDFATHER TIME: When Evening Comes")])])]), _vm._v(" "), _c('p', {
    staticClass: "firstverse"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/OWPATan",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "indent"
  }, [_vm._v("One Who Paid Attention:")]), _vm._v(" "), _c('i', [_vm._v("Hwee Hwee Tan—Becoming What We Look At")])])]), _vm._v(" "), _c('p', {
    staticClass: "firstverse"
  }, [_c('b', [_c('span', {
    attrs: {
      "href": "#/Text/Epilogue",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("EPILOGUE: The Journey Home")])])]), _vm._v(" "), _c('p', {
    staticClass: "firstverse"
  }, [_c('b', [_c('span', {
    attrs: {
      "href": "#/Text/Appendix",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("APPENDIX: Observing the Hours")])])]), _vm._v(" "), _c('p', {
    staticClass: "firstverse"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/InAttentiontoGratitude",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("In Attention to Gratitude")])]), _vm._v(" "), _c('p', {
    staticClass: "firstverse"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Notes",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('p', {
    staticClass: "firstverse"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Permissions",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Permissions")])]), _vm._v(" "), _c('p', {
    staticClass: "firstverse"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/endorsements",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Praise for "), _c('em', [_vm._v("The Attentive Life")])])]), _vm._v(" "), _c('p', {
    staticClass: "firstverse"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/author",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])]), _vm._v(" "), _c('p', {
    staticClass: "firstverse"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Formatio",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Formatio")])]), _vm._v(" "), _c('p', {
    staticClass: "firstverse"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/MoreTitlesfromIVP",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("More Titles from InterVarsity Press")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-78ee341a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/contents.vue
// module id = 69
// module chunks = 0